/**
 * 处理获取antdcss前缀
 */
class AntPrefixCls {
	defaultPrefixCls = 'ant';
	prefixCls;

	get = () => {
		return this.prefixCls || this.defaultPrefixCls;
	};

	set = prefixcls => {
		this.prefixCls = prefixcls;
	};
}

export const antPrefixCls = new AntPrefixCls();
